import script from "./Transactions.vue?vue&type=script&lang=ts&setup=true"
export * from "./Transactions.vue?vue&type=script&lang=ts&setup=true"

import "./Transactions.vue?vue&type=style&index=0&id=1d32762a&lang=scss"

const __exports__ = script;

export default __exports__